import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Button,
} from "@mui/material";
import api from "../../../../services/api";
import { useSnackbarAlert } from "../../../../hooks/useSnackbarAlert";
import IngredientSection from "../CostProfileForm/IngredientSection";
import ComponentDetailsSection from "./ComponentDetailsSection";
import getCostPerBaseUnit from "../../../../utils/cost/getCostPerBaseUnit";

const emptyComponent = {
  name: "",
  type: "",
  yieldNotes: "",
  componentYield: "",
  componentYieldUnit: "g",
  ingredients: [],
  components: [],
  includeLabor: false,
  laborMinutes: 0,
  laborRate: 0,
  includePackaging: false,
  packaging: [],
  manualAdjustments: [],
  wasteBufferPercent: 0,
  isComponent: true,
};

const ReusableComponentFormModal = ({ open, onClose, onSuccess }) => {
  const snackbar = useSnackbarAlert();
  const [form, setForm] = useState(emptyComponent);
  const [ingredients, setIngredients] = useState([]);

  useEffect(() => {
    if (open) setForm(emptyComponent); // Reset on open
  }, [open]);

  useEffect(() => {
    const fetchIngredients = async () => {
      try {
        const res = await api.get("/admin/ingredients");
        setIngredients(res.data);
      } catch (err) {
        console.error("Failed to fetch ingredients", err);
      }
    };
    fetchIngredients();
  }, []);

  const updateField = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        ...form,
        ingredients: form.ingredients.map((i) => ({
          ingredientId: i.ingredientId,
          quantity: Number(i.quantity),
          unit: i.unit,
        })),
        components: form.components.map((c) => ({
          componentId: c.componentId,
          usedGrams: Number(c.usedGrams),
        })),
      };

      await api.post("/admin/cost-profiles", payload);
      snackbar.success("Reusable component created.");
      onSuccess();
      onClose();
    } catch (err) {
      console.error(err);
      snackbar.error("Failed to create reusable component.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Add Reusable Component</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <ComponentDetailsSection
            form={form}
            updateField={updateField}
            ingredientsMaster={ingredients}
          />
          <IngredientSection
            form={form}
            updateField={updateField}
            ingredients={ingredients}
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained">
          Create Component
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReusableComponentFormModal;
